import React from 'react';
import { Box, Typography, Grid, Link } from '@mui/material';
import imagemevento from 'components/assets/imagens/logo-evento.png';
import { useDevice } from 'components/DeviceContext.js';

// Array de objetos para links do menu
const linksMenu = [
  { label: "INSCRIÇÕES", href: "https://intranet.cnm.org.br/223/22303001.asp?slCD_ORIGEM=851", target:"_blank" },
];

const MenuFooter = () => {
	const { isMobile } = useDevice();

	return (
		<Box sx={{ backgroundColor: 'var(--azul-subfooter)', color: '#fff', padding: '4em' }}>
				<Grid container spacing={2}>
					{/* Links de Menu */}
					<Grid item xs={12} md={3}>
						<Box sx={{ display: 'flex', flexDirection: 'column', textAlign: isMobile ? 'center' : 'left', color: 'var(--amarelo)' }}>
							{linksMenu.map((link, index) => (
								<Link 
									key={index} 
									href={link.href} 
									underline="none" 
									target={link.target}
									sx={{ marginBottom: '10px', color: 'var(--amarelo)', textDecoration: 'none', fontWeight: 'bold' }} 
								>
									{link.label}
								</Link>
							))}
						</Box>
					</Grid>

					{/* Centro com o título e imagem */}
					<Grid item xs={12} sm={12} md={5}>
						<Box sx={{ textAlign: 'center' }}>
							<img
								src={imagemevento}
								alt="Ilustração do evento"
								style={{
									marginBottom: '20px',
									width: isMobile ? '100%' : '70%',
									height: isMobile ? '100%' : '60%',
								}}
							/>
						</Box>
					</Grid>

					{/* Informações do evento */}
					<Grid item xs={12} md={4}>
						<Box sx={{ textAlign: isMobile ? 'center' : 'right' }}>
							<Typography variant="body1" sx={{ color: 'var(--laranja)', fontWeight: 'bold', marginBottom: '10px' }}>
								Local do evento:
							</Typography>
							<Typography variant="body1" sx={{ fontWeight: 'bold' }}>
								Complexo Casa das Histórias de Salvador
							</Typography>
							{["Rua Portugal n° 2, Edf Arquivo Público de Salvador ", " Auditório Makota Valdina 11° andar", "Salvador – BA"].map((line, index) => (
								<Typography key={index} variant="body1">
									{line}
								</Typography>
							))}
							<Link target="_blanck" href="https://www.google.com/maps/place/Casa+das+Hist%C3%B3rias+de+Salvador/@-12.9728553,-38.5160826,17z/data=!4m10!1m2!2m1!1sComplexo+Casa+das+Hist%C3%B3rias+de+Salvador+Rua+Portugal+n%C2%B0+2,+Edf+Arquivo+P%C3%BAblico+de+Salvador+Audit%C3%B3rio+Makota+Valdina+11%C2%B0+andar!3m6!1s0x716055a21e75769:0x614d4b8da4b4871d!8m2!3d-12.9728553!4d-38.5135077!15sCoIBQ29tcGxleG8gQ2FzYSBkYXMgSGlzdMOzcmlhcyBkZSBTYWx2YWRvciBSdWEgUG9ydHVnYWwgbsKwIDIsIEVkZiBBcnF1aXZvIFDDumJsaWNvIGRlIFNhbHZhZG9yIEF1ZGl0w7NyaW8gTWFrb3RhIFZhbGRpbmEgMTHCsCBhbmRhciIDiAEBkgEGbXVzZXVt4AEA!16s%2Fg%2F11qg9wfvnh?entry=ttu&g_ep=EgoyMDI0MTAyMy4wIKXMDSoASAFQAw%3D%3D" underline="none" color="#FF8C00" sx={{ marginTop: '10px', display: 'block' }}>
							Como chegar
							</Link>
						</Box>
					</Grid>
				</Grid>
		</Box>
	);
};

export default MenuFooter;
